

import React from 'react';
import './Pricing.css';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  const handlePurchase = (plan) => {
    if (plan === 'basic') {
      navigate('/basic-plan');
    } else if (plan === 'pro') {
      navigate('/pro-plan');
    } else if (plan === 'proPlus') {
      navigate('/proPlus-plan');
    }
  };

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-title">Pricing</div>
      <div className="pricing-plans">
        <div className="pricing-plan">
        <div className="pricing-free">
          <h3 className="title">Free</h3>
          <div className="price">$0/week</div>
          <ul className="features">
            <li><i className="fa-solid fa-circle-check"></i>View basic analytics and insights.</li>
            <li><i className="fa-solid fa-circle-check"></i>Access to support via email with standard response times.</li>
            </ul>
          <button className="pricing-button" onClick={() => handlePurchase('basic')}>Start Now </button>
        </div></div>
        <div className="pricing-plan popular">  
          <h3 className="title">Premium</h3>
          <div className="price">$10/month</div>
          <ul className="features">
        
            <li><i className="fa-solid fa-circle-check"></i>Everything in Free</li>
            <li><i className="fa-solid fa-circle-check"></i>Advanced and customizable notifications for sensitive data exposure.</li>
            <li><i className="fa-solid fa-circle-check"></i> Comprehensive analytics, insights, and reporting.</li>
            <li><i className="fa-solid fa-circle-check"></i>Ability to integrate with other tools or platforms.</li>
          </ul>
          <button className="pricing-button" onClick={() => handlePurchase('pro')}>Start 7 Day Trial</button>
        </div>
        <div className="pricing-plan">
          <h3 className="title">Pro Plus</h3>
          <div className="price">$15/month</div>
          <ul className="features">
          <li><i className="fa-solid fa-circle-check"></i>Everything in Premium</li>
          <li><i className="fa-solid fa-circle-check"></i>Managing multiple users or team accounts.</li>
          <li><i className="fa-solid fa-circle-check"></i>Scalable solutions to accommodate growing business needs.</li>
          <li><i className="fa-solid fa-circle-check"></i>Detailed reports for regulatory compliance and auditing.</li> 
          </ul>
          <button className="pricing-button" onClick={() => handlePurchase('proPlus')}>Start 7 Day Trial</button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;


